import { Tooltip } from "primereact/tooltip";
import {
  StatusIndicator,
  StatusText,
} from "styles/devices/deviceDetails.styles";
import {
  ConnectionToggle,
  ConnectionToggleOption,
  ParamConnectionSlot,
} from "styles/devices/deviceTable.styles";

interface ParamConnectionCellProps {
  isConnected: boolean;
  pendingConnected: boolean;
  isEditing: boolean;
  disabled?: boolean;
  disabledMessage?: string;
  switchId: string;
  onToggle: () => void;
  staticLabel?: string;
}

export function ParamConnectionCell({
  isConnected,
  pendingConnected,
  isEditing,
  disabled = false,
  disabledMessage = "",
  switchId,
  onToggle,
  staticLabel,
}: ParamConnectionCellProps) {
  if (staticLabel) {
    return (
      <ParamConnectionSlot>
        <StatusIndicator connected={true} />
        <StatusText connected={true}>{staticLabel}</StatusText>
      </ParamConnectionSlot>
    );
  }

  if (isEditing) {
    return (
      <ParamConnectionSlot>
        {disabled && disabledMessage && (
          <Tooltip
            target={`#${switchId}`}
            content={disabledMessage}
            position="top"
          />
        )}
        <ConnectionToggle id={switchId} role="group" aria-label="Connection state">
          <ConnectionToggleOption
            type="button"
            $active={pendingConnected}
            disabled={disabled}
            aria-pressed={pendingConnected}
            onClick={() => {
              if (!pendingConnected) onToggle();
            }}
          >
            Connected
          </ConnectionToggleOption>
          <ConnectionToggleOption
            type="button"
            $active={!pendingConnected}
            disabled={disabled}
            aria-pressed={!pendingConnected}
            onClick={() => {
              if (pendingConnected) onToggle();
            }}
          >
            Disconnected
          </ConnectionToggleOption>
        </ConnectionToggle>
      </ParamConnectionSlot>
    );
  }

  return (
    <ParamConnectionSlot>
      <StatusIndicator connected={isConnected} />
      <StatusText connected={isConnected}>
        {isConnected ? "Connected" : "Disconnected"}
      </StatusText>
    </ParamConnectionSlot>
  );
}
